module.exports = __webpack_public_path__ + "static/media/ic_download.82af533e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ic_download.svg
// module id = 543
// module chunks = 0